module.exports = __webpack_public_path__ + "01798bc13e33afc36a52f2826638d386.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Pe-icon-7-stroke.ttf?d7yf1v
// module id = 74
// module chunks = 0